(function (d) {
  var s = d.createElement("script");
  s.setAttribute("data-account", "Z44hVTOIpD");
  s.setAttribute("src", "https://cdn.userway.org/widget.js"); // Enclosed in quotation marks
  (d.body || d.head).appendChild(s);
})(document)